// extracted by mini-css-extract-plugin
export var clickableWrapper = "_2e-2";
export var placeholderIcon = "_2e-3";
export var thumbnailCanvas = "_2e-1";
export var thumbnailWrapper = "_2e-0";